import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LAYOUT_FEATURE_KEY, LayoutState, layoutAdapter } from './layout.reducer';

// Lookup the 'Layout' feature state managed by NgRx
export const selectLayoutState = createFeatureSelector<LayoutState>(LAYOUT_FEATURE_KEY);

const { selectAll, selectEntities } = layoutAdapter.getSelectors();

export const selectLayoutLoaded = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.loaded,
);

export const selectLayoutError = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.error,
);

export const selectAllLayout = createSelector(selectLayoutState, (state: LayoutState) =>
  selectAll(state),
);

export const selectLayoutEntities = createSelector(selectLayoutState, (state: LayoutState) =>
  selectEntities(state),
);

export const selectSelectedId = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.selectedId,
);

export const selectIndicators = createSelector(selectLayoutState, (state: LayoutState) => state);

export const selectEntity = createSelector(
  selectLayoutEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);

export const selectLeftColumnVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.leftColumnVisible,
);

export const selectRightColumnVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.rightColumnVisible,
);

export const selectLeftDrawerOpen = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.leftDrawerOpen,
);

export const selectRightDrawerOpen = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.rightDrawerOpen,
);
